module.exports = __webpack_public_path__ + "dash_20_app_assets/img/content-img-2.00ef7d97.jpg";